export default __webpack_public_path__ + "static/media/16.68617ef2.jpg";